

const Email = ({ enCode, attributes, clickOpenMailTo, reverseString }) => {
    const { content } = attributes;
    const revEmail = reverseString(content?.email);

    return <a href={`${enCode}`} target='__blank' onClick={() => { event.preventDefault(); clickOpenMailTo(content); }}>{revEmail}<div id='innerContainer'></div></a>
}
export default Email;